<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'ClientFillRateFilter',
  mixins: [baseMixin],
  model: {
    prop: 'filter',
    event: 'filterUpdated',
  },
  props: {
    filter: { type: Number, required: true },
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    hasIcon(option) {
      return option?.icon
    },
    hasText(option) {
      return option?.text
    },
    filterChanged(value) {
      this.$emit('filterUpdated', value)
      this.$emit('filterChanged', value)
    },
  },
}
</script>

<template>
  <v-btn-toggle
    :value="filter"
    group
    dense
    color="primary"
    mandatory
    @change="filterChanged"
  >
    <v-tooltip
      v-for="option of !options ? defaultLayoutOptions : options"
      :key="option.id"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn :id="option.id" small class="rounded" v-bind="attrs" v-on="on">
          <v-icon v-if="hasIcon" small>{{ option.icon }}</v-icon>
          <span v-if="hasText">{{ option.text }}</span>
        </v-btn>
      </template>
      <span v-text="option.tooltip"></span>
    </v-tooltip>
  </v-btn-toggle>
</template>
